import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_secured/reporting/dashboards/$boardId/',
)({
  async beforeLoad({ context }) {
    const hasViewPermission = await context.hasPermission(
      'campaignInsightsFeature:view',
    );
    if (!hasViewPermission) {
      throw redirect({
        to: '/campaigns',
      });
    }
  },
  async loader({ context, params }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/dashboards-builder');
    const title = i18n.t(`Dashboards - {{boardId}} | MINT`, {
      boardId: params.boardId,
    });
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
